import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import PopoverBase from '../../helpers/PopoverBase/PopoverBase';
import { KEY_CODES } from '../../helpers/constants';
import styles from '@patternfly/react-styles/css/components/Popover/popover';
import '@patternfly/react-styles/css/components/Tooltip/tippy.css';
import '@patternfly/react-styles/css/components/Tooltip/tippy-overrides.css';
import { css } from '@patternfly/react-styles';
import { PopoverContent } from './PopoverContent';
import { PopoverBody } from './PopoverBody';
import { PopoverHeader } from './PopoverHeader';
import { PopoverFooter } from './PopoverFooter';
import { PopoverCloseButton } from './PopoverCloseButton';
import { GenerateId } from '../../helpers/GenerateId/GenerateId';
import popoverMaxWidth from '@patternfly/react-tokens/dist/js/c_popover_MaxWidth';
import { FocusTrap } from '../../helpers';
export var PopoverPosition;

(function (PopoverPosition) {
  PopoverPosition["auto"] = "auto";
  PopoverPosition["top"] = "top";
  PopoverPosition["bottom"] = "bottom";
  PopoverPosition["left"] = "left";
  PopoverPosition["right"] = "right";
})(PopoverPosition || (PopoverPosition = {}));

export var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).call(this, props));

    _this.hideOrNotify = function () {
      if (_this.props.isVisible === null) {
        // Handle closing
        _this.tip.hide();
      } else {
        // notify consumer
        _this.props.shouldClose(_this.tip);
      }
    };

    _this.handleEscOrEnterKey = function (event) {
      if (event.keyCode === KEY_CODES.ESCAPE_KEY && _this.tip.state.isVisible) {
        _this.hideOrNotify();
      } else if (!_this.state.isOpen && event.keyCode === KEY_CODES.ENTER) {
        _this.setState({
          focusTrapActive: true
        });
      }
    };

    _this.storeTippyInstance = function (tip) {
      if (_this.props.minWidth) {
        tip.popperChildren.tooltip.style.minWidth = _this.props.minWidth;
      }

      tip.popperChildren.tooltip.classList.add(styles.popover);
      _this.tip = tip;
    };

    _this.closePopover = function () {
      _this.hideOrNotify();

      _this.setState({
        focusTrapActive: false
      });
    };

    _this.hideAllPopovers = function () {
      document.querySelectorAll('.tippy-popper').forEach(function (popper) {
        if (popper._tippy) {
          popper._tippy.hide();
        }
      });
    };

    _this.onHide = function (tip) {
      if (_this.state.isOpen) {
        _this.setState({
          isOpen: false
        });
      }

      return _this.props.onHide(tip);
    };

    _this.onHidden = function (tip) {
      return _this.props.onHidden(tip);
    };

    _this.onMount = function (tip) {
      return _this.props.onMount(tip);
    };

    _this.onShow = function (tip) {
      var _this$props = _this.props,
          hideOnOutsideClick = _this$props.hideOnOutsideClick,
          isVisible = _this$props.isVisible,
          onShow = _this$props.onShow; // hide all other open popovers first if events are managed by us

      if (!hideOnOutsideClick && isVisible === null) {
        _this.hideAllPopovers();
      }

      if (_this.state.isOpen === false) {
        _this.setState({
          isOpen: true
        });
      }

      return onShow(tip);
    };

    _this.onShown = function (tip) {
      return _this.props.onShown(tip);
    };

    _this.onContentMouseDown = function () {
      if (_this.state.focusTrapActive) {
        _this.setState({
          focusTrapActive: false
        });
      }
    };

    _this.state = {
      isOpen: false,
      focusTrapActive: false
    };
    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleEscOrEnterKey, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleEscOrEnterKey, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /* eslint-disable @typescript-eslint/no-unused-vars */
      var _a = this.props,
          position = _a.position,
          enableFlip = _a.enableFlip,
          children = _a.children,
          className = _a.className,
          ariaLabel = _a['aria-label'],
          headerContent = _a.headerContent,
          bodyContent = _a.bodyContent,
          footerContent = _a.footerContent,
          isVisible = _a.isVisible,
          shouldClose = _a.shouldClose,
          appendTo = _a.appendTo,
          hideOnOutsideClick = _a.hideOnOutsideClick,
          onHide = _a.onHide,
          onHidden = _a.onHidden,
          onShow = _a.onShow,
          onShown = _a.onShown,
          onMount = _a.onMount,
          zIndex = _a.zIndex,
          minWidth = _a.minWidth,
          maxWidth = _a.maxWidth,
          closeBtnAriaLabel = _a.closeBtnAriaLabel,
          distance = _a.distance,
          boundary = _a.boundary,
          flipBehavior = _a.flipBehavior,
          tippyProps = _a.tippyProps,
          rest = __rest(_a, ["position", "enableFlip", "children", "className", 'aria-label', "headerContent", "bodyContent", "footerContent", "isVisible", "shouldClose", "appendTo", "hideOnOutsideClick", "onHide", "onHidden", "onShow", "onShown", "onMount", "zIndex", "minWidth", "maxWidth", "closeBtnAriaLabel", "distance", "boundary", "flipBehavior", "tippyProps"]);
      /* eslint-enable @typescript-eslint/no-unused-vars */


      if (!headerContent && !ariaLabel) {
        return new Error('aria-label is required when header is not used');
      }

      var content = this.state.isOpen ? React.createElement(GenerateId, null, function (randomId) {
        return React.createElement(FocusTrap, {
          active: _this2.state.focusTrapActive,
          focusTrapOptions: {
            clickOutsideDeactivates: true
          }
        }, React.createElement("div", Object.assign({
          className: css(!enableFlip && (styles.modifiers[position] || styles.modifiers.top), className),
          role: "dialog",
          "aria-modal": "true",
          "aria-label": headerContent ? undefined : ariaLabel,
          "aria-labelledby": headerContent ? "popover-".concat(randomId, "-header") : undefined,
          "aria-describedby": "popover-".concat(randomId, "-body"),
          onMouseDown: _this2.onContentMouseDown
        }, rest), React.createElement(PopoverContent, null, React.createElement(PopoverCloseButton, {
          onClose: _this2.closePopover,
          "aria-label": closeBtnAriaLabel
        }), headerContent && React.createElement(PopoverHeader, {
          id: "popover-".concat(randomId, "-header")
        }, headerContent), React.createElement(PopoverBody, {
          id: "popover-".concat(randomId, "-body")
        }, bodyContent), footerContent && React.createElement(PopoverFooter, null, footerContent))));
      }) : React.createElement(React.Fragment, null);
      var handleEvents = isVisible === null;

      var shouldHideOnClick = function shouldHideOnClick() {
        if (handleEvents) {
          if (hideOnOutsideClick === true) {
            return true;
          }

          return 'toggle';
        }

        return false;
      };

      return React.createElement(PopoverBase, Object.assign({}, tippyProps, {
        arrow: true,
        onCreate: this.storeTippyInstance,
        maxWidth: maxWidth,
        zIndex: zIndex,
        appendTo: appendTo,
        content: content,
        lazy: true,
        trigger: handleEvents ? 'click' : 'manual',
        isVisible: isVisible,
        hideOnClick: shouldHideOnClick(),
        theme: "pf-popover",
        interactive: true,
        interactiveBorder: 0,
        placement: position,
        distance: distance,
        flip: enableFlip,
        flipBehavior: flipBehavior,
        boundary: boundary,
        popperOptions: {
          modifiers: {
            preventOverflow: {
              enabled: enableFlip
            },
            hide: {
              enabled: enableFlip
            }
          }
        },
        onHide: function onHide(tip) {
          return _this2.onHide(tip);
        },
        onHidden: function onHidden(tip) {
          return _this2.onHidden(tip);
        },
        onShow: function onShow(tip) {
          return _this2.onShow(tip);
        },
        onShown: function onShown(tip) {
          return _this2.onShown(tip);
        },
        onMount: function onMount(tip) {
          return _this2.onMount(tip);
        }
      }), children);
    }
  }]);

  return Popover;
}(React.Component);
Popover.defaultProps = {
  position: 'top',
  enableFlip: true,
  className: '',
  isVisible: null,
  shouldClose: function shouldClose() {
    return null;
  },
  'aria-label': '',
  headerContent: null,
  footerContent: null,
  appendTo: function appendTo() {
    return document.body;
  },
  hideOnOutsideClick: true,
  onHide: function onHide() {
    return null;
  },
  onHidden: function onHidden() {
    return null;
  },
  onShow: function onShow() {
    return null;
  },
  onShown: function onShown() {
    return null;
  },
  onMount: function onMount() {
    return null;
  },
  zIndex: 9999,
  maxWidth: popoverMaxWidth && popoverMaxWidth.value,
  closeBtnAriaLabel: 'Close',
  distance: 25,
  boundary: 'window',
  // For every initial starting position, there are 3 escape positions
  flipBehavior: ['top', 'right', 'bottom', 'left', 'top', 'right', 'bottom'],
  tippyProps: {}
};